<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col>
          <el-card class="box-card">
            <div class="Header">
              <span>{{ UploadHeader }}: </span>
            </div>
            <el-upload
              action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
              class="upload-demo"
              :file-list="fileList"
              :on-success="handleSuccess"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              list-type="text"
              ref="upload"
              :auto-upload="true"
            >
              <el-tooltip
                content="Clic para seleccionar archivos"
                placement="top"
              >
                <el-button
                  icon="el-icon-paperclip"
                  size="medium"
                  type="primary"
                ></el-button>
              </el-tooltip>

              <!-- <el-tooltip content="Clic para guardar archivos" placement="top">
                <el-button
                  icon="el-icon-upload"
                  size="medium"
                  type="success"
                  @click="submitUpload"
                ></el-button>
              </el-tooltip> -->

              <div slot="tip" class="el-upload__tip">
                Solo archivos jpg/png con un tamaño menor de 500kb
              </div>
            </el-upload>
            <!-- <el-tooltip content="Clic para guardar archivos" placement="top">
                <el-button
                  icon="el-icon-upload"
                  size="medium"
                  type="success"
                  @click="submitUpload"
                ></el-button>
              </el-tooltip> -->
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
//import axios from "axios";
export default {
  name: "CustomersFilesUploader",
  setup() {},
  props: {
    UploadHeader: {
      type: String,
      default: "",
      required: true
    },
    DocumentType: {
      type: Number,
      default: 0,
      required: true
    },
    CustomerCode: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      fileList: [],
      documentType: 0,
      customerCode: ""
    };
  },
  mounted(CustomerCode, documentType) {
    this.fileList = [];
    documentType = this.DocumentType;
    CustomerCode = this.CustomerCode;
    this.GetDocuments(CustomerCode, documentType);
  },
  methods: {
    /*
    submitUpload() {
      this.$refs.upload.submit();
    },
    */
    async GetDocuments(CustomerCode, DocumentType) {
      const Api = "/api/customers/getCustomersDocuments";
      //const params = `/CustomerCode=${CustomerCode}&DocumentType=${DocumentType}`;

      const params = {
        params: {
          CustomerCode: CustomerCode,
          DocumentType: DocumentType,
          IsEaneable: true
        }
      };

      await this.$http
        .get(Api, params)
        .then((resp) => {
          let { data } = resp;
          data.forEach((doc) => {
            if (this.fileList.name != doc.DocumentName) {
              this.fileList.push({
                name: doc.DocumentName,
                url: doc.DocumentUrl,
                uid: doc.DocumentUid
              });
            }
          });
        })
        .catch((err) => {
          console.error(
            `${err.name}:  ${err.message} `,
            "\n Error Detail: ",
            err
          );
          /*
          this.$message({
            type: "error",
            message: `${err.name}:  ${err.message} `,
            center: true
          });
          */
        })
        .finally(() => {});
    },
    handleRemove(file /*, fileList*/) {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          /*
          this.$message({
            type: "success",
            message: "Delete completed"
          });
          */
          const Api = "/api/customers/disableCustomersDocuments";

          const params = {
            CustomerCode: this.CustomerCode,
            DocumentType: this.DocumentType,
            DocumentName: file.name,
            DocumentUrl: file.url,
            DocumentUid: file.uid,
            IsEaneable: false
          };
          this.$http
            .put(Api, params)
            .then((resp) => {
              let { DocumentName } = resp.data;
              this.$message({
                showClose: true,
                message: `Se ha eliminado el archivo "${DocumentName}" satisfactoriamente`,
                type: "success",
                center: true,
                offset: 30
              });
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: `${err.name}:  ${err.message} `,
                center: true
              });
            })
            .finally(() => {});
        })
        .catch((CustomerCode, documentType) => {
          this.$message({
            type: "info",
            message: "Se ha cancelado el borrado del documento"
          });
          this.fileList = [];
          documentType = this.DocumentType;
          CustomerCode = this.CustomerCode;
          this.GetDocuments(CustomerCode, documentType);
        });
    },
    handlePreview(file) {
      // URL.createObjectURL(file.response[0].Url);
      let link = document.createElement("a");
      link.href = Object.prototype.hasOwnProperty.call(file, "url")
        ? file.url
        : file.response[0].Url; //file.response[0].Url != null || file.response[0].Url != undefined? file.response[0].Url :
      link.download = "download";
      link.target = "_blank";
      link.click();
    },
    handleSuccess(response, file /*, fileList*/) {
      //this.fileList.push({})

      const Api = "/api/customers/saveCustomersDocuments";
      let fechaActual = new Date("Jul 12 2011");
      const params = {
        CustomerCode: this.CustomerCode,
        DocumentType: this.DocumentType,
        DocumentName: file.response[0].Name,
        DocumentUrl: file.response[0].Url,
        DocumentUid: file.uid,
        IsEaneable: true,
        CreatedAt: fechaActual
      };
      this.$http
        .post(Api, params)
        .then((resp) => {
          let { DocumentName } = resp.data;
          this.$message({
            showClose: true,
            message: `Se ha guardado el archivo "${DocumentName}" satisfactoriamente`,
            type: "success",
            center: true,
            offset: 30
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: `${err.name}:  ${err.message} `,
            center: true
          });
        })
        .finally(() => {});
    }
  },
  watch: {
    CustomerCode(CustomerCode, documentType) {
      this.fileList = [];
      documentType = this.DocumentType;
      CustomerCode = this.CustomerCode;
      this.GetDocuments(CustomerCode, documentType);
    }
  }
};
</script>

<style scoped>
.Header {
  color: Black;
  padding-bottom: 15px;
}
</style>
